import React from 'react'
import { useDrop } from 'react-dnd'

import { DragItem } from 'common/builder/components/builder/SortableButton/types'
import SortableGroups from 'constants/SortableGroups'

interface EmptyTargetProps {
  children: React.ReactNode
  disabled: boolean
  onMove: (dragId: string) => void
  className?: string
}

export const EmptyTarget = ({ className, children, onMove, disabled }: EmptyTargetProps) => {
  const [, drop] = useDrop<DragItem, void, undefined>({
    accept: SortableGroups.BUTTON_LIST,
    hover({ buttonId }, monitor) {
      if (!monitor.isOver({ shallow: true })) {
        return
      }
      if (disabled) {
        return
      }
      onMove(buttonId)
    },
  })

  return (
    <div ref={drop} className={className}>
      {children}
    </div>
  )
}
